import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CurrencyService } from '../currency-table/currency.service';
import { HomeContentService } from './services/home-content.service';
import { ExhibitionContentService } from '../events/exhibitions/services/exhibition.Content.Service';
import { CouresesContentService } from '../events/seminars/services/coureses-content.service';
import { SeminarContentService } from '../events/lectures/service/seminar-content.service';
import { NewsContentService } from 'src/app/core/home-banner/services/news-content.service';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import * as AOS from 'aos';
import { FilterDto } from 'src/app/shared/models/filter';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  filter: FilterDto = new FilterDto();
  exhibitionSliderData: any[] = [];
  coursesData: any[] = [];
  seminarData: any[] = [];
  paginatedEvents: any = [];
  homeData: any = [];
  usdRate: number = 0;
  egpRate: number = 0;
  currencyData: Array<{ symbol: string, value: string }> = [];
  currencyTimeLastUpdate: string = '';
  convertCurrencyForm!: FormGroup;
  convertedAmount: number = 0;

  constructor(
    private _HomeContentService: HomeContentService,
    private _ExhibitionContentService: ExhibitionContentService,
    private _CouresesContentService: CouresesContentService,
    private _SeminarContentService: SeminarContentService,
    private _NewsContentService: NewsContentService,
    private currencyService: CurrencyService
  ) {
    this._HomeContentService.watch().valueChanges.subscribe(
      (result: any) => {
        this.homeData = result.data.queryHomepageContents;
      }
    );

    this._NewsContentService.watch({
      filter: '',
      skip: this.filter.skip,
      top: this.filter.top
    }).valueChanges.subscribe(
      (result: any) => {
        if (result && result['data']['queryNewsContents']) {
          this.paginatedEvents = this.chunkArray(result['data']['queryNewsContents'], 5);
        }
      }
    );

    this._ExhibitionContentService.watch({
      filter: ``,
      skip: this.filter.skip,
      top: this.filter.top
    }).valueChanges.subscribe((result: any) => {
      if (result && result['data']['queryConferencesContents'].length > 0) {
        this.exhibitionSliderData = result['data']['queryConferencesContents'];
      }
    });

    this._CouresesContentService.watch({
      filter: ``,
      skip: this.filter.skip,
      top: this.filter.top
    }).valueChanges.subscribe((resultData: any) => {
      if (resultData && resultData['data']['queryCoursesContentsWithTotal']['items'].length > 0) {
        this.coursesData = resultData['data']['queryCoursesContentsWithTotal']['items'];
      }
    });

    this._SeminarContentService.watch({
      filter: ``,
      skip: this.filter.skip,
      top: this.filter.top
    }).valueChanges.subscribe((resultData: any) => {
      if (resultData && resultData['data']['querySeminarsContentsWithTotal']['items'].length > 0) {
        this.seminarData = resultData['data']['querySeminarsContentsWithTotal']['items'];
      }
    });

    this.currencyService.getCurrencies("egp").subscribe((res: any) => {
      if (res.result) {
        this.currencyTimeLastUpdate = res['time_last_update_utc'];
        this.currencyData = Object.keys(res['conversion_rates']).map((key) => ({
          symbol: key,
          value: res['conversion_rates'][key]
        }));
        this.setInitialCurrencyValues();
      }
    });

    this.convertCurrencyForm = new FormGroup({
      first: new FormControl('USD'),
      firstInput: new FormControl(1), // يمكن تعديل القيمة الافتراضية هنا
      second: new FormControl('EGP'),
      secondInput: new FormControl(0),
    });
  }

  ngOnInit(): void {
    AOS.init();
    this.fetchCurrencyRates();
  }

  setInitialCurrencyValues(): void {
    const fromCurrency = 'USD';
    const toCurrency = 'EGP';
    const fromRate = parseFloat(
      this.currencyData.find((item) => item.symbol === fromCurrency)?.value || '1'
    );
    const toRate = parseFloat(
      this.currencyData.find((item) => item.symbol === toCurrency)?.value || '1'
    );

    const inputValue = 1; // القيمة الافتراضية للعملة الأولى
    this.convertedAmount = (inputValue * fromRate) / toRate;

    this.convertCurrencyForm.patchValue({
      first: fromCurrency,
      second: toCurrency,
      firstInput: inputValue,
      secondInput: this.convertedAmount,
    });
  }

  fetchCurrencyRates(): void {
    this.currencyService.getCurrencies('egp').subscribe((res: any) => {
      if (res.result) {
        const conversionRates = res['conversion_rates'];
        this.usdRate = Number(conversionRates['USD']) || 1;
        this.egpRate = Number(conversionRates['EGP']) || 0;
      }
    });
  }

  filterCurrencyBySymbol(res: any, secondSelect: any) {
    return Object.keys(res['conversion_rates']).map((key) => ({
      symbol: key,
      value: res['conversion_rates'][key]
    })).filter((currency: any) => currency['symbol'] === secondSelect);
  }

  updateConvertedAmount(): void {
    const fromCurrency = this.convertCurrencyForm.get('first')?.value;
    const toCurrency = this.convertCurrencyForm.get('second')?.value;
    const inputValue = this.convertCurrencyForm.get('firstInput')?.value || 0;

    const fromRate = parseFloat(
      this.currencyData.find((item) => item.symbol === fromCurrency)?.value || '1'
    );
    const toRate = parseFloat(
      this.currencyData.find((item) => item.symbol === toCurrency)?.value || '1'
    );

    this.convertedAmount = (inputValue * fromRate) / toRate;
    this.convertCurrencyForm.patchValue({
      secondInput: this.convertedAmount,
    });
  }

  reset() {
    this.convertCurrencyForm.reset({
      first: 'USD',
      second: 'EGP',
      firstInput: 1,
      secondInput: 0
    });
    this.updateConvertedAmount();
  }

  cancel() {
    // Implement the logic for cancel button if needed
  }

  chunkArray<T>(array: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  @ViewChild('slickModalNext') slickModalNext!: SlickCarouselComponent;
  @ViewChild('slickModalLatest') slickModalLatest!: SlickCarouselComponent;

  active = 1;
  itemsPerSlide = 3;
  singleSlideOffset = false;
  noWrap = false;
  searchText: string = '';
  currentPage: number = 1;
  pageSize: number = 6;
  page = 4;

  sliderConfig = {
    rtl: false,
    dots: false,
    arrows: true,
    autoplay: false,
    speed: 1000,
    infinite: true,
    pauseOnHover: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  };

  next() {
    if (this.slickModalNext) {
      this.slickModalNext.slickNext();
    }
  }

  prev() {
    if (this.slickModalNext) {
      this.slickModalNext.slickPrev();
    }
  }

  latestNext() {
    if (this.slickModalLatest) {
      this.slickModalLatest.slickNext();
    }
  }

  latestPrev() {
    if (this.slickModalLatest) {
      this.slickModalLatest.slickPrev();
    }
  }

  onSlideRangeChange(indexes: number[] | void): void {
    console.log(`Slides have been switched: ${indexes}`);
  }

  isCenterCard(index: number): boolean {
    return index % 3 === 1; // 0-based index for center card in each row
  }

  openModel() {
    const modelDiv = document.getElementById('myModal');
    if (modelDiv != null) {
      modelDiv.style.display = 'flex';
    }
  }

  CloseModel() {
    const modelDiv = document.getElementById('myModal');
    if (modelDiv != null) {
      modelDiv.style.display = 'none';
    }
  }
}
